export default __webpack_public_path__ + "static/media/5.31677c22.PNG";